import { AuthenticationService } from './../../servicios/authentication.service';
import { Component, OnInit, EventEmitter,  ViewChild } from '@angular/core';
import { Aguas, PersonaClientes, BuscaTramite, EstadoCuentaInformacionInput, SolicitudDetalles, FlujoTramitesInput } from '../../entidades/entidades'; // prettier-ignore
import { FormGroup, FormBuilder } from '@angular/forms';
import { async } from 'rxjs/internal/scheduler/async';
import { BuscaPersonaClientesService } from 'app/servicios/busca-persona-clientes.service';
import { SolicitudDetallesGridComponent } from '../solicitud-detalles-grid/solicitud-detalles-grid.component';
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { SolicitudDetallesService } from "../../servicios/solicitud-detalles.service";
import { FlujoTramitesInputService } from '../../servicios/flujo-tramites.service';
import {RegistroBitacoraInput} from '../../entidades/entidades'
import { RegistroBitacoraService } from '../../servicios/registro-bitacora.service';

import { Router, ActivatedRoute } from "@angular/router";
import { AguasService } from '../../servicios/aguas.service';
import { from } from 'rxjs';
import { IfStmt } from '@angular/compiler';


@Component({
  selector: "app-baja-de-cuenta",
  templateUrl: "./baja-de-cuenta.component.html",
  styleUrls: ["./baja-de-cuenta.component.css"],
})
export class BajaDeCuentaComponent implements OnInit {
  @ViewChild(SolicitudDetallesGridComponent, { static: false })
  childSolicitudDetallesGrid;

  public estadoCuentaInformacionInput$ = new EventEmitter<
    EstadoCuentaInformacionInput
  >();
  public estadoCuentaInformacionLimpio: EstadoCuentaInformacionInput;
  muestraMensaje = new MuestraMensaje();

  usuario: any;
  datosPClientesForm: FormGroup;
  datosClientes = new PersonaClientes();
  public IdSolicitud: number;
  public IdAgua: number;
  datos: any;
  public registroBitacora = new RegistroBitacoraInput();
  btnBajaDisabled = false;
  btnReactivarDisabled = false;
  ///////PROGRESS BAR///////////////////
  public progressBar = false;
  mensajeForm: FormGroup;
  showBar() {
    this.progressBar = true;
  }
  public titulo: string = "Baja De Cuenta / Reactivación de Cuenta";
  ////////////////////////////////////////////////
  // @ViewChild(EstadoCuentaInformacionComponent, { static: false }) childEstadoCuentaInformacion;

  constructor(
    private aguasService: AguasService,
    private buscaPersonaClientesService: BuscaPersonaClientesService,
    private activatedRoute: ActivatedRoute,
    private solicitudDetallesService: SolicitudDetallesService,
    private router: Router,
    private flujoTramitesInputService: FlujoTramitesInputService,
    private formBuilder: FormBuilder,
    private authenticationService:AuthenticationService,
    private registroBitacoraService: RegistroBitacoraService

  ) {}

  async ngOnInit() {
    try {
      await this.authenticationService.getUserByToken();
      this.usuario = this.authenticationService.currentUserValue;

      this.mensajeForm = this.formBuilder.group({
        mensaje_: [undefined],
      });
      this.datos = history.state.example;
      if (this.datos) {
        this.IdSolicitud = this.datos.idSolicitud;
        this.IdAgua = this.datos.idAgua;
        console.log("this.router: ", this.datos.idSolicitud);
        this.mensajeForm.patchValue({
          mensaje_: "Consultando...",
        });
        this.showBar();
        this.confirmaSolicitud();
        this.ObtieneInfo();
      } else {
        this.router.navigateByUrl("/");
      }
    } catch {
      this.muestraMensaje.notification(
        "No existe una solicitud Previa",
        "top",
        "center"
      );
    }
  }

  async confirmaSolicitud() {
    try {
      const datoRetorno = await this.solicitudDetallesService
        .getSingle(this.IdSolicitud)
        .toPromise();
      let solDetalle = new SolicitudDetalles();
      solDetalle = datoRetorno;

      console.log("datoRetorno: ", datoRetorno);

      if (datoRetorno.id == 0) {
        this.muestraMensaje.error(
          "Esta solicitud no corresponde a una baja de cuenta",
          "top",
          "center"
        );
        this.router.navigateByUrl("/");
    
      }
      switch(solDetalle.idConcepto)
      {
        case 138:
          this.btnBajaDisabled      = false;
          this.btnReactivarDisabled = true;
          this.titulo = "Baja De Cuenta";
          break;
        case 139:
          this.btnBajaDisabled      = true;
          this.btnReactivarDisabled = false;
          this.titulo = "Reactivación de Cuenta";
          break;
      }
      // if(solDetalle.idEstatus == 2 || solDetalle.idEstatus == 4)
      // {
      //   this.muestraMensaje.error("Este servicio ya pasó por Ejecución", "top", "center");
      //   this.router.navigateByUrl("/");
      // }
    } catch {
    } finally {
      console.log("Paso por confirmaSolicitud");
    }
  }

  async ObtieneInfo() {
    try {
      await this.estadoCuentaInformacionInput$.emit(null);
      let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
      estadoCuentaInformacionInput.idAgua = this.IdAgua;

      await this.estadoCuentaInformacionInput$.emit(
        estadoCuentaInformacionInput
      );

    } catch {
    } finally {
      this.progressBar = false;
      console.log("ya muestRA el estado ");
    }
  }

  async ActualizarEstatus(condicion: String) {
    try {
      let aguas = new Aguas();
      aguas.id = this.IdAgua;
      
      if (condicion === "C") {
        this.btnReactivarDisabled = true;
   
        aguas.idEstatus = 4; /// cancelado
        aguas.fechaBaja = new Date(Date.now());
        this.registroBitacora.idAgua = this.IdAgua;
        this.registroBitacora.idMovAsegurar = 1;
        this.registroBitacora.accion = "SE DIO DE BAJA LA CUENTA", this.IdAgua;
        const datoRetorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();
 
      } else if (condicion === "R") {
        this.btnBajaDisabled = true;
        aguas.idEstatus = 1; /// Reactivar
        this.registroBitacora.idAgua = this.IdAgua;
        this.registroBitacora.idMovAsegurar = 1;
        this.registroBitacora.accion = "SE REACTIVO LA CUENTA", this.IdAgua;
        const datoRetorno = await this.registroBitacoraService.add(this.registroBitacora).toPromise();
        

      }
      console.log("Aguas", aguas);
      const datoRetorno = await this.aguasService.actualiza(aguas).toPromise();

      let flujoSolicitudes = new FlujoTramitesInput();
      flujoSolicitudes.idSolicitudDetalle = this.IdSolicitud;
      flujoSolicitudes.idUsuario = this.usuario.id;
      flujoSolicitudes.inicio = false;

      await this.flujoTramitesInputService.add(flujoSolicitudes).toPromise();
      await this.ObtieneInfo();
      await this.muestraMensaje.notification(
        "Proceso Concluido",
        "top",
        "center"


      );
    } catch (error) {
      this.muestraMensaje.error(error.message, "top", "center");
    }
  }
}
